export const GET_ALLERGEN = 'GET_ALLERGEN';
export const GET_ALLERGEN_ERROR = 'GET_ALLERGEN_ERROR';

export const GET_ALLERGEN_REPORT = 'GET_ALLERGEN_REPORT';
export const GET_ALLERGEN_REPORT_ERROR = 'GET_ALLERGEN_REPORT_ERROR';
export const GET_ALLERGEN_TEACHERS = 'GET_ALLERGEN_TEACHERS';

export const ALLERGEN_REPORT_LOAD = 'ALLERGEN_REPORT_LOAD';
export const ALLERGEN_FIELDS_LOADING = 'ALLERGEN_FIELDS_LOADING';
export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';



// WEBPACK FOOTER //
// ./src/pages/studentallergies/state/types.js